import { useState, useEffect } from "react";

export const formatTime = (seconds: number) => {
  let formatted = "";
  if (seconds > 60 * 60) {
    formatted = `${(seconds / (60 * 60)).toFixed(1)} hr`;
  } else if (seconds > 60) {
    formatted = `${(seconds / 60).toFixed(1)} min`;
  } else {
    formatted = `${seconds.toFixed(1)} sec`;
  }
  return formatted;
};

const useJobProgress = (props: {
  progressNumerator?: number;
  progressDenominator?: number;
  secondsElapsed?: number;
  progressStartDate?: string;
  startDate?: string;
  status?: string;
}) => {
  const {
    progressDenominator,
    progressNumerator,
    secondsElapsed: elapsed,
    status,
    progressStartDate,
    startDate,
  } = props;
  const secondsElapsed = elapsed ?? 0;

  const [now, setNow] = useState(Date.now());
  const [currentProgressNumerator, setCurrentProgressNumerator] =
    useState(progressNumerator);

  useEffect(() => {
    if (progressNumerator !== currentProgressNumerator) {
      setCurrentProgressNumerator(progressNumerator);
      setNow(Date.now());
    }
  }, [progressNumerator, currentProgressNumerator]);

  let progressText = "";
  let elapsedText = formatTime(secondsElapsed);
  const percentComplete =
    (progressNumerator ?? 0) / (progressDenominator || 100);
  const start = new Date(progressStartDate ?? startDate ?? "").valueOf();
  const totalTime = (now - start) / percentComplete;
  const eta = start + totalTime;
  const etaString = new Date(eta).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  });
  if (status === "success") {
    progressText = elapsedText;
  } else if (status === "running") {
    progressText = `${Math.round(percentComplete * 100)}% ${
      (progressNumerator ?? 0) > 0 ? `(${etaString})` : ""
    }`;
  } else if (status === "error") {
    progressText = `${Math.round(percentComplete * 100)}% (${elapsedText})`;
  }

  return {
    label: status === "running" ? "Progress" : "Execution Time",
    value: progressText,
  };
};

export default useJobProgress;
